<agpr-dialog-container
    [id]="'wireConfirmation'"
    [contentPadding]="false"
    (close)="closeDialog()"
    [heading]="heading"
>
    <div
        class="agpr-wireConfirmation"
        [agprLoading]="loading"
    >
        <agpr-scroll-panel  *ngIf="wire">
            <div class="agpr-wireConfirmation-header">
                <span class="agpr-wireConfirmation-headerIcon agpr-i-line-bullhorn" aria-hidden="true"></span>
                <div class="agpr-wireConfirmation-headerText">
                    <p class="agpr-wireConfirmation-headerMainText">{{ 'Amplify.wire.confirmation.headerMainText' | localize }}</p>
                    <p class="agpr-wireConfirmation-headerSubText">{{ 'Amplify.wire.confirmation.headerSubText' | localize }}</p>
                    <p class="agpr-wireConfirmation-instructionLine">{{ 'Amplify.wire.confirmation.instructionLine' | localize }}</p>
                </div>
            </div>
            <div class="agpr-wireConfirmation-padding-wrapper">
                <div class="agpr-wireConfirmation-wireDetails">
                    <div class="agpr-wireConfirmation-wireDetails-row">
                        <label class="agpr-wireConfirmation-wireDetails-row-label">
                            {{ 'Amplify.wire.confirmation.releaseName' | localize }}
                        </label>
                        <label>
                            {{ wire.name }}
                        </label>
                    </div>

                    <div class="agpr-wireConfirmation-wireDetails-row">
                        <label class="agpr-wireConfirmation-wireDetails-row-label">
                            {{ 'Amplify.wire.confirmation.headLine' | localize }}
                        </label>
                        <label>
                            {{ wire.headline }}
                        </label>
                    </div>

                    <div class="agpr-wireConfirmation-wireDetails-row">
                        <label class="agpr-wireConfirmation-wireDetails-row-label">
                            {{ 'Amplify.wire.confirmation.companyName' | localize }}
                        </label>
                        <label>
                            {{ wire.companyName }}
                        </label>
                    </div>

                    <div class="agpr-wireConfirmation-wireDetails-row">
                        <label class="agpr-wireConfirmation-wireDetails-row-label">
                            {{ 'Amplify.wire.confirmation.releaseDate' | localize }}
                        </label>
                        <label>
                            {{ scheduledTime }}
                        </label>
                    </div>

                    <div class="agpr-wireConfirmation-wireDetails-row">
                        <label class="agpr-wireConfirmation-wireDetails-row-label">
                            {{ 'Amplify.wire.publicationRegions' | localize }}
                        </label>
                        <label>
                            {{ 'WireRegion.' + wire.regions[0] | localize }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="agpr-wireConfirmation-disclaimer">
                <agpr-checkbox
                    id="wireConfirmation_disclaimerCheckbox"
                    [label]="disclaimer"
                    ariaLabelledBy="wireConfirmation_additionalDisclaimer"
                    [value]="disclaimerApproved"
                    (onChange)="disclaimerApproved = !disclaimerApproved"
                ></agpr-checkbox>
                <div
                    *ngIf="additionalDisclaimer"
                    id="wireConfirmation_additionalDisclaimer"
                    class="agpr-wireConfirmation-disclaimer-secondParagraph"
                >
                    {{additionalDisclaimer | localize}}
                </div>
            </div>
        </agpr-scroll-panel>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            id="cancelButton"
            label="Core.button.cancel"
            (click)="closeDialog()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="confirmationButton"
            label="Amplify.wire.confirmation.agreeAndSubmit"
            [disabled]="!disclaimerApproved"
            (click)="submitWire()"
            [style]="buttonTypes.primary"
        ></agpr-button>
    </ng-template>

</agpr-dialog-container>
